export const LINKED_OPTIONS_FETCH = 'LINKED_OPTIONS_FETCH'
export const LINKED_OPTIONS_SUCCESS = 'LINKED_OPTIONS_SUCCESS'
export const LINKED_OPTIONS_FAILED = 'LINKED_OPTIONS_FAILED'

export const FILTER_OPTIONS_FETCH = 'FILTER_OPTIONS_FETCH'
export const FILTER_OPTIONS_SUCCESS = 'FILTER_OPTIONS_SUCCESS'
export const FILTER_OPTIONS_FAILED = 'FILTER_OPTIONS_FAILED'

export const FILTER_OPTIONS_RESET = 'FILTER_OPTIONS_RESET'
